import { FormControl } from 'baseui/form-control'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '../../useAddress'

const HeatingEnergy = () => {
  const { t, updateAddress, energyLandscape, heatingEnergy, heatingOptions, errors } = useAddress()
  const error = getError('heatingMode', errors)

  return (
    <FormControl error={error}>
      <SDSelect
        label={t('subscriptionTools:estimator.heating_mode.label')}
        translationsPath='subscriptionForm:address_module.heating_types.'
        newTranslations={true}
        optionsList={heatingOptions}
        onChangeHandler={params =>
          updateAddress({
            heatingEnergy: params.option?.id,
            energyLandscape: {
              ...energyLandscape,
              heatPump: params.option?.id !== 'elec' ? false : energyLandscape.heatPump,
            },
          })
        }
        selectedValue={heatingEnergy ? heatingEnergy.toString() : ''}
        hasError={!!error}
      />
    </FormControl>
  )
}
export default HeatingEnergy
